import clsx from 'clsx';

import { Icon } from '@atom/mui';
import colors from '@atom/styles/colors';
import { WorkOrderTab } from '@atom/types/work';

import classes from './workOrderDetailHeader.module.css';

export interface Props {
  view: {
    value: WorkOrderTab;
    label: string;
    icon: string;
    dataCy: string;
  };
  activeView: WorkOrderTab;
  setActiveView: (view: WorkOrderTab) => void;
}

const DetailHeaderButton = ({ view, activeView, setActiveView }: Props) => {
  const { value, label, icon, dataCy } = view;

  return (
    <div
      onClick={() => setActiveView(value)}
      className={clsx(
        classes.iconContainer,
        activeView === value && classes.active,
      )}
      data-cy={dataCy}
    >
      <div className={classes.icon}>
        <Icon color={colors.neutral.white} children={icon} />
      </div>
      <div className={classes.label}>{label}</div>
    </div>
  );
};

export default DetailHeaderButton;
